import { Input, LegacyCard, LegacyForm, Typography } from "@payping/web-components";
import { isAlphabet } from "@payping/utils/string";
import { useAppTranslation } from "@/utils";
import type { FormInstance } from "@payping/web-components/legacyComponents/Form/types";
import { Dispatch, FC, SetStateAction } from "react";
import { SamanConfiguration } from "@/pages/DigitalAccount/Saman/Create";

interface Props {
  form: FormInstance<SamanConfiguration>;
  setRequestTitle: Dispatch<SetStateAction<string>>;
  setRequestDescription: Dispatch<SetStateAction<string>>;
}

const FirstStepSaman: FC<Props> = ({ form, setRequestTitle, setRequestDescription }) => {
  const { t } = useAppTranslation();
  return (
    <LegacyForm<SamanConfiguration>
      name={"SamanConfiguration"}
      onValuesChange={(changedValues) => {
        if ("title" in changedValues && changedValues.title) {
          setRequestTitle(changedValues.title);
        }
        if ("description" in changedValues && changedValues.description) {
          setRequestDescription(changedValues.description);
        }
      }}
      form={form}
      className="tw:w-full"
      layout={"vertical"}
    >
      <LegacyCard.Ant
        title={
          <Typography.Title type={"secondary"} level={5}>
            {t("digitalAccount.samanCreate.fileSetting")}
          </Typography.Title>
        }
      >
        <LegacyForm.Item
          label={t("digitalAccount.samanCreate.listName")}
          name={"title"}
          rules={[{ required: true, min: 5 }]}
          wrapperCol={{ lg: 6 }}
        >
          <Input className="tw:w-full" />
        </LegacyForm.Item>
        <LegacyForm.Item
          wrapperCol={{ lg: 10 }}
          name={"description"}
          label={t("description")}
          rules={[
            { required: true },
            {
              validator(_, value) {
                if (!isAlphabet(value, { withNumber: true }))
                  return Promise.reject(new Error(t("settlement.error.descriptionException")));
                if (value && value.length > 50) return Promise.reject(new Error(t("settlement.error.description")));
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={t("digitalAccount.samanCreate.sampleDesSaman")} />
        </LegacyForm.Item>
      </LegacyCard.Ant>
    </LegacyForm>
  );
};

export default FirstStepSaman;
